import React from "react";
import styled from "styled-components";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => (
  <StyledTabPanel
    role="tabpanel"
    hidden={value !== index}
    id={`scrollable-prevent-tabpanel-${index}`}
    aria-labelledby={`scrollable-prevent-tab-${index}`}
    {...other}
  >
    {value === index && children}
  </StyledTabPanel>
);

const StyledTabPanel = styled.div`
  background: #292b2f;
  color: white;
  /* changes the sub tabs in preview*/
  .MuiTab-textColorPrimary {
    color: grey;
  }
  .MuiTab-textColorPrimary.Mui-selected {
    color: white;
  }
`;

export default TabPanel;
